import { Routes, Route } from 'react-router-dom';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import LoginPage from '@/pages/LoginPage';

const Login = () => (
    <Routes>
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<LoginPage />} />
    </Routes>
);

export default Login;
